import { InsightsClass } from '@helpers/Insights.class';

window.addEventListener('DOMContentLoaded', () => {
  const insightsElements = document.querySelectorAll<HTMLElement>('.kf-o-insights');

  insightsElements.forEach((element) => new InsightsClass(element));
});
